import React, { useEffect, useRef, useState } from 'react'
import Cookies from 'universal-cookie'

// Accent first, background second
const colours = [
  ['#28cf52', '#06160a'],
  ['#E6E7E8', '#050505'],
  ['#FEE715FF', '#101820FF'],
  ['#EC4D37', '#1D1B1B'],
  ['#2a2927', '#e7dfd6'],
]
const DEFAULT_COLOUR = 2

const ColourToggles = () => {
  const [open, setOpen] = useState(false)
  const [selected, setSelected] = useState(DEFAULT_COLOUR)
  const wrapperRef = useRef(null)

  const setColour = (colour) => {
    const cookies = new Cookies()
    cookies.set('colour', colour, { path: '/' })
    document.documentElement.style.setProperty('--main-color', colours[colour][0])
    document.documentElement.style.setProperty('--background-color', colours[colour][1])
    setSelected(parseInt(colour, 10))
  }

  const changeColour = (e) => {
    setColour(e.currentTarget.dataset.colour)
  }

  // Set the colour according to stored cookie
  useEffect(() => {
    const cookies = new Cookies()
    const colour = cookies.get('colour')
    setColour(colours[colour] ? colour : DEFAULT_COLOUR)
  }, [])

  // Close the menu on outside click or Escape
  useEffect(() => {
    if (!open) return undefined
    const onDown = (e) => {
      if (!wrapperRef.current.contains(e.target)) setOpen(false)
    }
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('pointerdown', onDown)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('pointerdown', onDown)
      document.removeEventListener('keydown', onKey)
    }
  }, [open])

  return (
    <div className={'colour-toggle' + (open ? ' open' : '')} ref={wrapperRef}>
      <button
        className="colour-chevron"
        aria-label="Change colour theme"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <svg viewBox="0 0 12 8" width="12" height="8" aria-hidden="true">
          <polyline points="1,1 6,6 11,1" />
        </svg>
      </button>
      <div className="colour-menu" aria-hidden={!open}>
        {colours.map(([accent, background], index) => (
          <button
            key={accent}
            className={'colour-btn' + (selected === index ? ' selected' : '')}
            data-colour={index}
            onClick={changeColour}
            tabIndex={open ? 0 : -1}
            aria-label={`Colour theme ${index + 1}`}
          >
            <span style={{ background: accent }}></span>
            <span style={{ background: background }}></span>
          </button>
        ))}
      </div>
    </div>
  )
}

export default ColourToggles
